module.exports = __webpack_public_path__ + "img/00047.16826a4d.webp";